// extracted by mini-css-extract-plugin
module.exports = {"container":"_1pDudc4Ny99T0cJbzR--li","configuration":"_2JpuEPQ7QB6uDFWho-_sS8"};